// TODO toggle this based on environment if needed for local development
export const SESSION_COOKIE_NAME = 'sessionid'

export const fetchUser = async (config, Cookie) => {
  const response = await fetch(`${config.public.apiUrl}/api/customer/user/`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      Cookie,
    },
  })

  return await response.json()
}
